import React, { Fragment, useEffect } from "react";
import { DIALOGHOLDER } from "@genericComponents/CFW.js";
import { MaintainDialog } from "@genericComponents/PFW.js";
import { GetStorage, SetStorage } from "@genericComponents/SFW.js";
import { SetState } from "@genericComponents/StoreToolkit.js";
import { User } from "@genericComponents/User.js";
const GetVisitorCountry =
  await import("@asyncImports/GetVisitorCountry.js").then(
    (mod) => mod.GetVisitorCountry,
  );
const CountryPermission = () => {
  const CFW_CLIENT_COUNTRY_DECLINED = "CFW_CLIENT_COUNTRY_DECLINED";
  const GetCountryVisitor = async () => {
    const permissionStatus = await navigator?.permissions?.query({
      name: "geolocation",
    });
    if (
      permissionStatus.state.toUpperCase() === "PROMPT" &&
      !GetStorage(CFW_CLIENT_COUNTRY_DECLINED)
    ) {
      const dialogParam = { ...MaintainDialog };
      dialogParam.msg = "689";
      dialogParam.title = "645";
      window.ncb = () => {
        SetStorage(CFW_CLIENT_COUNTRY_DECLINED, "1");
      };
      window.pcb = () => {
        GetVisitorCountry(true);
      };
      dialogParam.shownb = true;
      SetState(DIALOGHOLDER, dialogParam);
    } else if (permissionStatus.state.toUpperCase() === "GRANTED") {
      GetVisitorCountry(true);
    }
  };
  useEffect(() => {
    const stateChange = (event) => {
      if (event.target.readyState === "complete") {
        if (navigator?.geolocation && !User.SelectedCountry()) {
          GetCountryVisitor();
        }
      }
    };
    document.removeEventListener("readystatechange", stateChange);
    document.addEventListener("readystatechange", stateChange);
    return () => {
      document.removeEventListener("readystatechange", stateChange);
    };
  }, []);
  return <Fragment />;
};
export default CountryPermission;
